/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CaptureRouteImport } from './routes/capture'
import { Route as ImportRouteImport } from './routes/import'
import { Route as KitRouteImport } from './routes/kit'
import { Route as LooksRouteImport } from './routes/looks'
import { Route as CreatorSlugRouteImport } from './routes/$creator.$slug'
import { Route as ImportIdRouteImport } from './routes/import.$id'
import { Route as PublishIdRouteImport } from './routes/publish.$id'
import { Route as ScanIdRouteImport } from './routes/scan.$id'
import { Route as SettingsPrivacyRouteImport } from './routes/settings.privacy'
import { Route as TryonIdRouteImport } from './routes/tryon.$id'
import { Route as RemixIdGoalsRouteImport } from './routes/remix.$id.goals'
import { Route as RemixIdPlanRouteImport } from './routes/remix.$id.plan'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CaptureRoute = CaptureRouteImport.update({
  id: '/capture',
  path: '/capture',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportRoute = ImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => rootRouteImport,
} as any)
const KitRoute = KitRouteImport.update({
  id: '/kit',
  path: '/kit',
  getParentRoute: () => rootRouteImport,
} as any)
const LooksRoute = LooksRouteImport.update({
  id: '/looks',
  path: '/looks',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorSlugRoute = CreatorSlugRouteImport.update({
  id: '/$creator/$slug',
  path: '/$creator/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportIdRoute = ImportIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ImportRoute,
} as any)
const PublishIdRoute = PublishIdRouteImport.update({
  id: '/publish/$id',
  path: '/publish/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ScanIdRoute = ScanIdRouteImport.update({
  id: '/scan/$id',
  path: '/scan/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPrivacyRoute = SettingsPrivacyRouteImport.update({
  id: '/settings/privacy',
  path: '/settings/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TryonIdRoute = TryonIdRouteImport.update({
  id: '/tryon/$id',
  path: '/tryon/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RemixIdGoalsRoute = RemixIdGoalsRouteImport.update({
  id: '/remix/$id/goals',
  path: '/remix/$id/goals',
  getParentRoute: () => rootRouteImport,
} as any)
const RemixIdPlanRoute = RemixIdPlanRouteImport.update({
  id: '/remix/$id/plan',
  path: '/remix/$id/plan',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/capture': typeof CaptureRoute
  '/import': typeof ImportRouteWithChildren
  '/kit': typeof KitRoute
  '/looks': typeof LooksRoute
  '/$creator/$slug': typeof CreatorSlugRoute
  '/import/$id': typeof ImportIdRoute
  '/publish/$id': typeof PublishIdRoute
  '/scan/$id': typeof ScanIdRoute
  '/settings/privacy': typeof SettingsPrivacyRoute
  '/tryon/$id': typeof TryonIdRoute
  '/remix/$id/goals': typeof RemixIdGoalsRoute
  '/remix/$id/plan': typeof RemixIdPlanRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/capture': typeof CaptureRoute
  '/import': typeof ImportRouteWithChildren
  '/kit': typeof KitRoute
  '/looks': typeof LooksRoute
  '/$creator/$slug': typeof CreatorSlugRoute
  '/import/$id': typeof ImportIdRoute
  '/publish/$id': typeof PublishIdRoute
  '/scan/$id': typeof ScanIdRoute
  '/settings/privacy': typeof SettingsPrivacyRoute
  '/tryon/$id': typeof TryonIdRoute
  '/remix/$id/goals': typeof RemixIdGoalsRoute
  '/remix/$id/plan': typeof RemixIdPlanRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/capture': typeof CaptureRoute
  '/import': typeof ImportRouteWithChildren
  '/kit': typeof KitRoute
  '/looks': typeof LooksRoute
  '/$creator/$slug': typeof CreatorSlugRoute
  '/import/$id': typeof ImportIdRoute
  '/publish/$id': typeof PublishIdRoute
  '/scan/$id': typeof ScanIdRoute
  '/settings/privacy': typeof SettingsPrivacyRoute
  '/tryon/$id': typeof TryonIdRoute
  '/remix/$id/goals': typeof RemixIdGoalsRoute
  '/remix/$id/plan': typeof RemixIdPlanRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/capture'
    | '/import'
    | '/kit'
    | '/looks'
    | '/$creator/$slug'
    | '/import/$id'
    | '/publish/$id'
    | '/scan/$id'
    | '/settings/privacy'
    | '/tryon/$id'
    | '/remix/$id/goals'
    | '/remix/$id/plan'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/capture'
    | '/import'
    | '/kit'
    | '/looks'
    | '/$creator/$slug'
    | '/import/$id'
    | '/publish/$id'
    | '/scan/$id'
    | '/settings/privacy'
    | '/tryon/$id'
    | '/remix/$id/goals'
    | '/remix/$id/plan'
  id:
    | '__root__'
    | '/'
    | '/capture'
    | '/import'
    | '/kit'
    | '/looks'
    | '/$creator/$slug'
    | '/import/$id'
    | '/publish/$id'
    | '/scan/$id'
    | '/settings/privacy'
    | '/tryon/$id'
    | '/remix/$id/goals'
    | '/remix/$id/plan'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CaptureRoute: typeof CaptureRoute
  ImportRoute: typeof ImportRouteWithChildren
  KitRoute: typeof KitRoute
  LooksRoute: typeof LooksRoute
  CreatorSlugRoute: typeof CreatorSlugRoute
  PublishIdRoute: typeof PublishIdRoute
  ScanIdRoute: typeof ScanIdRoute
  SettingsPrivacyRoute: typeof SettingsPrivacyRoute
  TryonIdRoute: typeof TryonIdRoute
  RemixIdGoalsRoute: typeof RemixIdGoalsRoute
  RemixIdPlanRoute: typeof RemixIdPlanRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capture': {
      id: '/capture'
      path: '/capture'
      fullPath: '/capture'
      preLoaderRoute: typeof CaptureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import': {
      id: '/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof ImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kit': {
      id: '/kit'
      path: '/kit'
      fullPath: '/kit'
      preLoaderRoute: typeof KitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/looks': {
      id: '/looks'
      path: '/looks'
      fullPath: '/looks'
      preLoaderRoute: typeof LooksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$creator/$slug': {
      id: '/$creator/$slug'
      path: '/$creator/$slug'
      fullPath: '/$creator/$slug'
      preLoaderRoute: typeof CreatorSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import/$id': {
      id: '/import/$id'
      path: '/$id'
      fullPath: '/import/$id'
      preLoaderRoute: typeof ImportIdRouteImport
      parentRoute: typeof ImportRoute
    }
    '/publish/$id': {
      id: '/publish/$id'
      path: '/publish/$id'
      fullPath: '/publish/$id'
      preLoaderRoute: typeof PublishIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scan/$id': {
      id: '/scan/$id'
      path: '/scan/$id'
      fullPath: '/scan/$id'
      preLoaderRoute: typeof ScanIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/privacy': {
      id: '/settings/privacy'
      path: '/settings/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof SettingsPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tryon/$id': {
      id: '/tryon/$id'
      path: '/tryon/$id'
      fullPath: '/tryon/$id'
      preLoaderRoute: typeof TryonIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/remix/$id/goals': {
      id: '/remix/$id/goals'
      path: '/remix/$id/goals'
      fullPath: '/remix/$id/goals'
      preLoaderRoute: typeof RemixIdGoalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/remix/$id/plan': {
      id: '/remix/$id/plan'
      path: '/remix/$id/plan'
      fullPath: '/remix/$id/plan'
      preLoaderRoute: typeof RemixIdPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ImportRouteChildren {
  ImportIdRoute: typeof ImportIdRoute
}

const ImportRouteChildren: ImportRouteChildren = {
  ImportIdRoute: ImportIdRoute,
}

const ImportRouteWithChildren =
  ImportRoute._addFileChildren(ImportRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CaptureRoute: CaptureRoute,
  ImportRoute: ImportRouteWithChildren,
  KitRoute: KitRoute,
  LooksRoute: LooksRoute,
  CreatorSlugRoute: CreatorSlugRoute,
  PublishIdRoute: PublishIdRoute,
  ScanIdRoute: ScanIdRoute,
  SettingsPrivacyRoute: SettingsPrivacyRoute,
  TryonIdRoute: TryonIdRoute,
  RemixIdGoalsRoute: RemixIdGoalsRoute,
  RemixIdPlanRoute: RemixIdPlanRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
